import styled, { css } from 'styled-components'
import Box from 'components/shared/Box'
import { respondBelow } from 'styles/mediaQueries'

interface DiscountBadgeBoxProps {
    isAbsolute?: boolean
    top?: number
    bottom?: number
    left?: number
    right?: number
}

export const DiscountBadgeBox = styled(Box)<DiscountBadgeBoxProps>`
    @media ${respondBelow.xs} {
        transform: scale(0.8);
    }

    position: ${({ isAbsolute }) => (isAbsolute ? 'absolute' : 'relative')};

    ${({ top }) =>
        top &&
        css`
            top: ${top}px;
        `}
    ${({ left }) =>
        left &&
        css`
            left: ${left}px;
        `}
    
    ${({ bottom }) =>
        bottom &&
        css`
            bottom: ${bottom}px;
        `}

    ${({ right }) =>
        right &&
        css`
            right: ${right}px;
        `}
`
